//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../../../EventBus/EventBus.js'
import { createFieldConfig } from '../../../../components/QSelectUtils.js'
import { parseUniqueKey } from '../ReportCheckListUniqueKey.js'
import { ACTIONS } from '../../../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNote.js'

import FilesField from '../../../../components/File/FilesField.vue'
import FilesGroup from '../../../../components/File/FilesGroup.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'
import ServiceObjectMaintenanceNoteOperation from '../../../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNoteOperation.vue'

export default {
  components: {
    FilesField,
    ItemsSearchField
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    },
    resultValue: {
      type: Object,
      default () {
        return {}
      }
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const openAll = this.resultValue.value.every(tg => tg.opened === true)
    return {
      selectedCam: null,
      opened: false,
      openAll: !!openAll,
      camsFieldConfig: createFieldConfig({ allRecordsFn: this.getCams })
    }
  },
  computed: {
    mobile: function () {
      return this.$store.getters.getUser.view === 'mobile'
    },
    filesGroupToCheckForIgnoreDuplicate: function () {
      return this.report.filesGroupsContainers.guiImgFiles.getFilesGroup('other')
    }
  },
  methods: {
    getCamPhotoLabelBefore: function (cam, tg, subgroup) {
      return 'До' + (this.getFilesGroupBefore(cam, tg, subgroup).files.length > 1 ? ` (${this.getFilesGroupBefore(cam, tg, subgroup).files.length})` : '')
    },
    getCamPhotoLabelAfter: function (cam, tg, subgroup) {
      return 'После' + (this.getFilesGroupAfter(cam, tg, subgroup).files.length > 1 ? ` (${this.getFilesGroupAfter(cam, tg, subgroup).files.length})` : '')
    },
    getFilesGroupBefore: function (cam, tg, subgroup) {
      return this.getFilesGroup(cam, tg, subgroup, 'before')
    },
    getFilesGroupAfter: function (cam, tg, subgroup) {
      return this.getFilesGroup(cam, tg, subgroup, 'after')
    },
    getFilesGroup: function (cam, tg, subgroup, type) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]
      const key = `${this.resultValue.uniqueKey}_${type}_${cam.camId}`

      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListCamMetro',
          key: key,
          props: {
            resultKey: key,
            camId: cam && cam.camId || null,
            deskId: cam && cam.deskId || null,
            tgId: tg && tg.tgId || null,
            subgroupId: subgroup && subgroup.subgroupId || null,
            type
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    },
    onFileTgAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          tgId: filesGroupProps.tgId,
          subgroupId: filesGroupProps.subgroupId,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    },
    onFileSubgroupBeforeAddToUpload: function (fileWrapper, filesGroup) {
      return this.onFileSubgroupAddToUpload(fileWrapper, filesGroup, 'before')
    },
    onFileSubgroupAfterAddToUpload: function (fileWrapper, filesGroup) {
      return this.onFileSubgroupAddToUpload(fileWrapper, filesGroup, 'after')
    },
    onFileSubgroupAddToUpload: function (fileWrapper, filesGroup, type) {
      const filesGroupProps = filesGroup.props
      if (filesGroup.filesToUpload.length > filesGroupProps.subgroup.cams.length) {
        filesGroup.deleteFile(fileWrapper)

        this.$q.notify({
          type: 'negative',
          message: 'Количество добавленных фото превысило количество камер в турникетной группе',
          progress: true,
          timeout: 8000
        })
      }
      filesGroup.filesToUpload.forEach((file, index) => {
        const cam = filesGroupProps.subgroup.cams[index]

        file.attributes = {
          resultKey: `${filesGroupProps.uniqueKey}_${type}_${cam.camId}`,
          camId: cam.camId,
          deskId: cam.deskId,
          tgId: filesGroupProps.tg.tgId,
          subgroupId: filesGroupProps.subgroup.subgroupId,
          type: type,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      })
    },
    isFileCamAddBtnHidden: function (cam) {
      return !(!!cam.deskId || cam.otherDeskIds && cam.otherDeskIds.length)
    },
    onFileCamAddToUpload: function (fileWrapper, filesGroup) {
      const filesGroupProps = filesGroup.props
      if (filesGroupProps) {
        fileWrapper.attributes = {
          resultKey: filesGroupProps.resultKey,
          camId: filesGroupProps.camId,
          deskId: filesGroupProps.deskId,
          tgId: filesGroupProps.tgId,
          subgroupId: filesGroupProps.subgroupId,
          type: filesGroupProps.type,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      }
    },
    getFilesGroupSubgroupBefore: function (tg, subgroup) {
      return this.getFilesGroupSubgroupWithType(tg, subgroup, 'before')
    },
    getFilesGroupSubgroupAfter: function (tg, subgroup) {
      return this.getFilesGroupSubgroupWithType(tg, subgroup, 'after')
    },
    getFilesGroupSubgroupWithType: function (tg, subgroup, type) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]
      const key = `${this.resultValue.uniqueKey}_${tg.tgId}_${subgroup.subgroupId}_cams_${type}`

      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListCamMetro',
          key: key,
          props: {
            resultKey: null,
            uniqueKey: this.resultValue.uniqueKey,
            tg: tg || null,
            subgroup: subgroup || null
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    },
    getFilesGroupTgSubroup: function (tg, subgroup) {
      const filesProperty = 'guiImgFiles'
      const filesGroupsContainer = this.report.filesGroupsContainers[filesProperty]

      const key = `${this.resultValue.uniqueKey}_${tg.tgId}_${subgroup.subgroupId}`
      let filesGroup = filesGroupsContainer.getFilesGroup(key)

      if (!filesGroup) {
        filesGroup = new FilesGroup({
          categoryKey: 'checkListCamMetro',
          key: key,
          props: {
            resultKey: key,
            tgId: tg && tg.tgId || null,
            subgroupId: subgroup && subgroup.subgroupId || null
          }
        })
        filesGroupsContainer.addFilesGroup(filesGroup)
      }

      return filesGroup
    },
    onUploadSuccessTg: function ({ document }, tg, sub) {
      const tgGroup = this.resultValue.value.find(tgGroup => tgGroup.tgId === tg.tgId)
      const subgroup = tgGroup.subgroups.find(s => s.subgroupId === sub.subgroupId)
      subgroup.subgroupPhoto.push(document.id)
    },
    onUploadSuccessBefore: function ({ document }, tg, subgroup, cam) {
      return this.onUploadSuccess(document.id, tg, subgroup, cam, 'photoBefore')
    },
    onUploadSuccessAfter: function ({ document }, tg, subgroup, cam) {
      return this.onUploadSuccess(document.id, tg, subgroup, cam, 'photoAfter')
    },
    onUploadSuccessSubgroupBefore: function ({ document, fileWrapper }, tg, subgroup) {
      const cam = { camId: fileWrapper.attributes.camId }
      return this.onUploadSuccess(document.id, tg, subgroup, cam, 'photoBefore')
    },
    onUploadSuccessCamsAfter: function ({ document, fileWrapper }, tg, subgroup) {
      const cam = { camId: fileWrapper.attributes.camId }
      return this.onUploadSuccess(document.id, tg, subgroup, cam, 'photoAfter')
    },
    onUploadSuccess: function (documentId, tg, sub, cam, property) {
      const tGroup = this.resultValue.value.find(tGroup => tGroup.tgId === tg.tgId)
      const subgroup = tGroup.subgroups.find(s => s.subgroupId === sub.subgroupId)
      const c = subgroup.cams.find(c => c.camId === cam.camId)
      c[property].push(documentId)
    },
    onRemoveSubgroupBefore: function (file, filesGroup) {
      return this.onRemoveSubgroup(filesGroup, 'before')
    },
    onRemoveSubgroupAfter: function (file, filesGroup) {
      return this.onRemoveSubgroup(filesGroup, 'after')
    },
    onRemoveSubgroup: function (filesGroup, type) {
      const filesGroupProps = filesGroup.props
      filesGroup.filesToUpload.forEach((file, index) => {
        const cam = filesGroupProps.subgroup.cams[index]

        file.attributes = {
          resultKey: filesGroupProps.resultKey,
          camId: cam.camId,
          deskId: cam.deskId,
          tgId: filesGroupProps.tg.tgId,
          subgroupId: filesGroupProps.subgroup.subgroupId,
          type: type,
          ...parseUniqueKey(this.resultValue.uniqueKey)
        }
      })
    },
    onRemovePhotoTg: function ({ file, filesGroup }, tg, sub) {
      filesGroup.removeFile(file)
      const tgGroup = this.resultValue.value.find(tgGroup => tgGroup.tgId === tg.tgId)
      const subgroup = tgGroup.subgroups.find(s => s.subgroupId === sub.subgroupId)
      subgroup.subgroupPhoto = subgroup.subgroupPhoto.filter(id => id !== file.id)
    },
    onRemovePhotoBefore: function ({ file, filesGroup }, tg, sub, cam) {
      return this.onRemovePhoto(file, filesGroup, tg, sub, cam, 'photoBefore')
    },
    onRemovePhotoAfter: function ({ file, filesGroup }, tg, sub, cam) {
      return this.onRemovePhoto(file, filesGroup, tg, sub, cam, 'photoAfter')
    },
    onRemovePhoto: function (file, filesGroup, tg, sub, cam, property) {
      filesGroup.removeFile(file)
      const tGroup = this.resultValue.value.find(tGroup => tGroup.tgId === tg.tgId)
      const subgroup = tGroup.subgroups.find(s => s.subgroupId === sub.subgroupId)
      const c = subgroup.cams.find(c => c.camId === cam.camId)
      c[property] = c[property].filter(id => id !== file.id)
    },
    onAddCam: function () {
      this.selectedCam = null
      this.opened = true
    },
    getCams: function () {
      const cams = []
      Object.keys(this.report.externalCameraTourniquetGroups).forEach(tgId => {
        const tgGroup = this.report.externalCameraTourniquetGroups[tgId]

        tgGroup.forEach(camInfo => {
          if (!camInfo.request && camInfo.object) {
            cams.push({ id: camInfo.object, name: camInfo.object, tgId: tgId })
          }
        })
      })

      return Promise.resolve(cams)
    },
    onSaveAddCam: function () {
      let tgGroup = this.resultValue.value.find(tgGroup => tgGroup.tgId === this.selectedCam.tgId)
      if (!tgGroup) {
        tgGroup = {
          tgId: this.selectedCam.tgId,
          tgPhoto: [],
          cams: []
        }
        this.resultValue.value.unshift(tgGroup)
      }

      const cam = {
        camId: this.selectedCam.id,
        deskId: null,
        comment: null,
        photoBefore: [],
        photoAfter: [],
        manual: true
      }
      tgGroup.cams.unshift(cam)
      this.onClose()
    },
    onDeleteCam: function (tg, cam) {
      const tgGroup = this.resultValue.value.find(tgGroup => tgGroup.tgId === tg.tgId)
      tgGroup.cams = tgGroup.cams.filter(c => c.camId !== cam.camId)
      if (tgGroup.cams.length === 0) {
        this.resultValue.value = this.resultValue.value.filter(t => t.tgId !== tg.tgId)
      }
    },
    onClose: function () {
      this.selectedCam = null
      this.opened = false
    },
    openAllMethod: function () {
      this.openAll = !this.openAll

      this.resultValue.value.forEach(tg => {
        tg.opened = this.openAll
      })
    },

    // Замечания к объекту обслуживания
    getTgNotes: function (tg) {
      const tgNotes = []
      tg.subgroups.forEach(subgroup => {
        subgroup.cams.forEach(cam => {
          tgNotes.push(...this.getCameraNotes(cam))
        })
      })

      return tgNotes
    },
    hasTgNotFixedNotes: function (tg) {
      return this.hasNotFixedNotes(this.getTgNotes(tg))
    },
    isFixedAllTgNotes: function (tg) {
      return this.isFixedAllNotes(this.getTgNotes(tg))
    },
    getCameraNotes: function (cam) {
      const camNotes = this.report.maintenanceNotes && this.report.maintenanceNotes.filter(note => note.serviceObject && note.serviceObject.key === cam.camId) || []
      return camNotes
    },
    getCameraNotCancelledNotes: function (cam) {
      return this.getCameraNotes(cam).filter(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key !== 'canceled')
    },
    hasCamNotFixedNotes: function (cam) {
      return this.hasNotFixedNotes(this.getCameraNotes(cam))
    },
    isFixedAllCamNotes: function (cam) {
      return this.isFixedAllNotes(this.getCameraNotes(cam))
    },
    hasNotFixedNotes: function (notes) {
      return !!notes.find(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'notFixed')
    },
    isFixedAllNotes: function (notes) {
      return notes.length && notes.filter(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key !== 'fixed').length === 0
    },
    getDisableNoteBtn: function (maintenanceNoteStatus, note) {
      const action = ACTIONS.find(action => action.toMaintenanceNoteStatus === maintenanceNoteStatus)
      if (action && action.displayFn) {
        return note.maintenanceNoteStatus && note.maintenanceNoteStatus.key !== maintenanceNoteStatus && !action.displayFn(note)
      }
      return false
    },
    getNoteProblem: function (note) {
      if (note && note.description) {
        const problemStart = 'Проблема: '
        const dateTimeStart = 'Дата/время: '

        const startIndex = note.description.indexOf(problemStart)
        const endIndex = note.description.indexOf(dateTimeStart)

        if (startIndex === -1 || endIndex === -1) {
          return note.description
        }

        return note.description.substring(startIndex + problemStart.length, endIndex).trim()
      }
    },
    onChangeNoteStatus: function (maintenanceNoteStatus, note) {
      const sourceProps = { recordSource: 'requestReport', serviceObjectId: this.serviceObject.id, serviceObjectName: this.serviceObject.name, serviceObjectType: this.serviceObject.type.key, requestReportId: this.report.id }

      const action = ACTIONS.find(action => action.toMaintenanceNoteStatus === maintenanceNoteStatus)

      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerHidden: true,
        contentComponent: ServiceObjectMaintenanceNoteOperation,
        contentProps: {
          recordId: note.id,
          record: note,
          action: action,
          sourceProps: sourceProps
        },
        componentHandlers: {
          update: () => {
            this.$set(note, 'loading', true)
            EventBus.$emit('update-notes', {})
          }
        }
      })
    }
  }
}

